import { Card } from "@/components/ui/card";
import { LineChart } from "@/components/ui/line-chart";

interface ChartCardProps {
  title: string;
  value: string;
  data: number[];
  labels?: string[];
}

export function ChartCard({ title, value, data, labels = ["Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep"] }: ChartCardProps) {
  return (
    <Card className='w-full h-full overflow-hidden rounded-2xl border border-(--background) bg-white flex flex-col'>
      <div className='p-6 flex-grow flex flex-col'>
        <div className='text-left'>
          <h3 className='text-sm font-normal text-gray-500'>{title}</h3>
          <p className='mt-1 text-[32px] leading-tight'>{value}</p>
        </div>
        <div className='mt-5 flex-grow'>
          <LineChart data={data} />
        </div>
      </div>
      <div className='flex justify-between bg-background px-6 py-3 text-xs text-gray-500 w-full'>
        {labels.map((label, index) => (
          <span key={index}>{label}</span>
        ))}
      </div>
    </Card>
  );
}
